import {
  type ExtractExperimentKeys,
  useFeatureFlag,
} from '#app/hooks/useFeatureFlag.js';
import { type Experiment, type FeatureFlags } from '@contra/feature-flags';

const DEFAULT_TEST_VALUE = 'test';

/**
 * Hook to determine if a feature flag is set to 'test'.
 */
export const useExperiment = (
  featureName: ExtractExperimentKeys<FeatureFlags>,
  testValueOverride?: Omit<Experiment, 'control'>,
): boolean => {
  const featureValue = useFeatureFlag(featureName);
  const testValue = testValueOverride ?? DEFAULT_TEST_VALUE;

  return featureValue === testValue;
};
